export function Cache(hash){
    let store = new Map();
    const getKey = (val)=>hash(val);
    const get = function(key){
        const k = getKey(key);
        return store.get(k);
    }
    const set = function(key, val){
        const k = getKey(key);
        store.set(k, val);
    }
    const del = function(key){
        const k = getKey(key);
        store.delete(k)
    }
    return {get, set, del};
}